import ListPartnerContainer from '../../containers/ListPartner';

interface Props {}

function Partner(props: Props) {
  return <ListPartnerContainer />;
}

export default Partner;
